export enum NewsAudienceEnum {
  ALL_USERS = 'ALL_USERS',
  ALL_COMPANIES = 'ALL_COMPANIES',
  ALL_USERS_IN_SPECIFIC_COMPANIES = 'ALL_USERS_IN_SPECIFIC_COMPANIES'
}
